module.exports = __webpack_public_path__ + "img/2020_12_20_dog.91583cb3.jpg";